"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTaskStore = exports.taskStore = void 0;
const store2_1 = __importDefault(require("store2"));
const helpers_1 = require("../tasks/shared/helpers");
const helpers_2 = require("../tasks/shared/helpers");
/**
 * Store for managing task state. For all tasks.
 *
 * @type {import('store2').StoreAPI & (() => TaskStore)}
 */
exports.taskStore = store2_1.default.page.namespace('taskStore');
const setTaskStore = (config) => {
    var _a;
    let story = true;
    const storyOption = config.storyOption ? config.storyOption.toLowerCase() : '';
    if (storyOption === 'true' || storyOption === 'false') {
        story = (0, helpers_1.stringToBoolean)(storyOption);
    }
    else if (storyOption === 'grade-based' && config.userMetadata.grade) {
        const grade = Number(config.userMetadata.grade);
        // If not a number, assume it's pk, tk, k, or invalid string (in which all cases default to show story)
        story = Number.isNaN(grade) || grade < 5;
    }
    const effectiveHeavyInstructions = config.heavyInstructions || config.userMetadata.age <= 4;
    (0, exports.taskStore)({
        itemSelect: 'mfi',
        trialNumSubtask: 0,
        testTrialCount: 0,
        totalTrialCount: 0,
        numIncorrect: 0,
        // For ROAR syntax (TROG)
        totalCorrect: 0,
        correctItems: [],
        // -----
        audioFeedback: config.audioFeedback,
        skipInstructions: config.skipInstructions,
        corpusId: config.corpusId,
        corpus: config.corpus,
        buttonLayout: config.buttonLayout,
        task: config.task,
        maxIncorrect: config.maxIncorrect,
        keyHelpers: config.keyHelpers,
        runCat: config.cat,
        heavyInstructions: effectiveHeavyInstructions && (0, helpers_2.isEnglish)(config.language),
        semThreshold: config.semThreshold,
        startingTheta: config.startingTheta,
        storeItemId: config.storeItemId,
        isRoarApp: config.isRoarApp,
        numOfBlocks: config.userMetadata.age > 4 ? 9 : 4,
        blockSize: config.userMetadata.age > 4 ? 30 : 50,
        stimulusBlocks: config.stimulusBlocks,
        gridSize: config.userMetadata.age > 4 ? 3 : 2,
        maxTimeReached: false,
        taskComplete: false,
        stimulus: 'heart',
        stimulusSide: 'left',
        stimulusPosition: 0,
        isCorrect: false,
        inferenceNumStories: config.inferenceNumStories,
        numberOfStories: config.numberOfStories,
        testPhase: false,
        story,
        maxTime: config.maxTime,
        demoMode: config.demoMode,
        experimenterButtons: config.experimenterButtons && effectiveHeavyInstructions,
        debug: config.debug,
        version: config.version || 1,
        currentStoryGroup: 0,
        taskTimer: null,
        taskTimerPausedMs: 0,
        taskTimerPauseBeganAt: null,
        isPaused: false,
        previousItem: undefined,
        previousAnswer: undefined,
        nextStimulus: undefined,
        scoringVersion: config.scoringVersion,
        irtEstimates: {},
        randomSeed: (_a = config.randomSeed) !== null && _a !== void 0 ? _a : null,
    });
};
exports.setTaskStore = setTaskStore;
// Leaving this for ROAR fork / documentation
// STATE
// audioFeedback: audioFeedback || 'neutral',
// skipInstructions: skipInstructions ?? true,
// comes from getCorpus after parsing the corpus
// corpora
// For ROAR. The name of the corpus file.
// corpusId: corpusId,
// buttonLayout: buttonLayout || 'default',
// task: taskName ?? 'egma-math',
// maxIncorrect: maxIncorrect ?? 3,
// keyHelpers: keyHelpers ?? true,
// storeItemId: storeItemId,
// isRoarApp: isRoarApp(firekit)
// DONT NEED STATE FOR THESE
// userMetadata: { ...userMetadata, age },
// startTime: new Date(),
// firekit,
// displayElement: displayElement || null,
// sequentialPractice: sequentialPractice ?? true,
// sequentialStimulus: sequentialStimulus ?? true,
// // name of the csv files in the storage bucket
// corpus: corpus,
// numberOfTrials: numberOfTrials ?? 300,
// stimulusBlocks: stimulusBlocks ?? 3,
// numOfPracticeTrials: numOfPracticeTrials ?? 2,
// language: language ?? i18next.language,
// maxTime: maxTime || 100,
